setTimeout(() => {
    const observer = new MutationObserver((mutationList) => {
        mutationList.forEach((mutation) => {
            const prevSibling = mutation.previousSibling;
            if (prevSibling instanceof Element && prevSibling.classList.contains("slide-cart-checkout-btn")) {
                BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.();
            }
        });
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}, 300);
